// extracted by mini-css-extract-plugin
module.exports = {"base":"focusedCard-m__base__8ROib","text-wrapper":"focusedCard-m__text-wrapper__JVs4p","section-name":"focusedCard-m__section-name__G-BnG"};